import IconArrival from "./ra-arrival.svg";
import IconDeparture from "./ra-departure.svg";
import ImgEmptyBox from "./ra-empty-box.png";
import IconSuccess from "./ra-icon-success.png";
import IconError from "./ra-icon-error.png";
import IconArrowUp from "./ra-arrow-up.svg";
import IconArrowDown from "./ra-arrow-down.svg";
import IconBringPets from "./ra-bring-pets.png";
import IconBringOversizeLuggage from "./ra-bring-oversize-luggage.png";
import IconInterestEmptyLegs from "./ra-interest-empty-legs.png";
import IconAircraftOutline from "./ra-aircraft-outline.svg";
import IconAircraftAirportFill from "./ra-aircraft-airport-fill.svg";
import IconWarningAlert from "./ra-warning-alert.svg";
import IconWNoPermission from "./ra-no-permission.png";
import IconWNoResults from "./ra-no-results.png";
import IconUserGroupSvg from "./ra-group-user.svg";
import IconSpeedSvg from "./ra-speed.svg";
import IconTimeSvg from "./ra-time.svg";
import IconAircraftBaloSvg from "./ra-aircraft-balo.svg";
import IconAircraftBagSvg from "./ra-aircraft-bag.svg";
import IconAircraftValiSvg from "./ra-aircraft-vali.svg";
import IconAircraftSkiingSvg from "./ra-aircraft-skiing.svg";
import IconAircraftGolfSvg from "./ra-aircraft-golf.svg";
import IconAircraftFillSvg from "./ra-aircraft-fill.svg";
import IconAvionicsSvg from "./ra-avionics.svg";
import IconMaintainanceSvg from "./ra-maintainance.svg";
import IconPartsAndInventorySvg from "./ra-parts-inventory.svg";
import IconOutlineAirFreightSvg from "./ra-outline-air-freight.svg";
import IconOutlineCharterSvg from "./ra-outline-charter.svg";
import IconOutlineJetOneSuitesSvg from "./ra-outline-jet-one-suites.svg";
import IconFillOriginAirFreightSvg from "./icon-origin-air-freight.svg";
import IconMenuSvg from "./icon-menu.svg";
import IconGlyphSvg from "./icon-glyph.svg";
import IconFillFirstNameBasistSvg from "./icon-first-name-basis.svg";
import IconFillPreciselyControlledSvg from "./icon-precisely-controlled.svg";
import IconClockSolutionsSvg from "./icon-clock-solutions.svg";
import IconMissionCriticalSpeedSvg from "./icon-mission-critical-speed.svg";
import IconDuplicationWarning from "./icon-duplication-warning.svg";
import IconAirFreight from "./icon-air-freight.svg";
import IconCharter from "./icon-charter.svg";
import IconJetOneSuites from "./icon-jet-1-suites.svg";
import IconSoftInventory from "./icon-inventory.svg";
import IconSoftMaintenance from "./icon-maintenance.svg";
import IconSoftAionics from "./icon-avionics.svg";
import IconFillEmailSvg from "./ra-fill-email.svg";
import IconFillPhoneSvg from "./ra-fill-phone.svg";
import IconFillAddressSvg from "./ra-fill-address.svg";
import IconFillSafetySvg from "./ra-safety.svg";
import IconFillBestRateSvg from "./ra-best-rate.svg";
import IconFillPrioritizedSvg from "./ra-prioritized.svg";
import IconFillTailorBenefitsSvg from "./ra-tailor-benefits.svg";
import IconAircraftCircle from "./ra-aircraft-circle.svg";
import IconAircraftCapacity from "./ra-aircraft-capacity.svg";
import IconAircraftRange from "./ra-aircraft-range.png";
import IconSwipe from "./ra-icon-swipe.png";
import IconHangar from "./ra-hangar.svg";
import IconEmployees from "./ra-employees.svg";
import ImageDashboardWelcomeDesktop from "./ra-dashboard-welcome-desktop.png";
import ImageDashboardWelcomeMobile from "./ra-dashboard-welcome-mobile.png";

export {
	IconDuplicationWarning,
	IconEmployees,
	IconHangar,
	IconAircraftRange,
	ImageDashboardWelcomeDesktop,
	ImageDashboardWelcomeMobile,
	IconSwipe,
	IconArrival,
	IconDeparture,
	ImgEmptyBox,
	IconSuccess,
	IconError,
	IconArrowUp,
	IconArrowDown,
	IconBringPets,
	IconBringOversizeLuggage,
	IconAircraftCircle,
	IconAircraftCapacity,
	IconInterestEmptyLegs,
	IconMenuSvg,
	IconGlyphSvg,
	IconAircraftOutline,
	IconAircraftAirportFill,
	IconWarningAlert,
	IconWNoPermission,
	IconWNoResults,
	IconSoftInventory,
	IconSoftMaintenance,
	IconSoftAionics,
	IconUserGroupSvg,
	IconSpeedSvg,
	IconTimeSvg,
	IconAirFreight,
	IconCharter,
	IconJetOneSuites,
	IconAircraftBaloSvg,
	IconAircraftBagSvg,
	IconAircraftGolfSvg,
	IconAircraftSkiingSvg,
	IconAircraftValiSvg,
	IconAircraftFillSvg,
	IconAvionicsSvg,
	IconMaintainanceSvg,
	IconPartsAndInventorySvg,
	IconOutlineAirFreightSvg,
	IconOutlineCharterSvg,
	IconOutlineJetOneSuitesSvg,
	IconFillEmailSvg,
	IconFillOriginAirFreightSvg,
	IconFillFirstNameBasistSvg,
	IconFillPreciselyControlledSvg,
	IconClockSolutionsSvg,
	IconMissionCriticalSpeedSvg,
	IconFillPhoneSvg,
	IconFillAddressSvg,
	IconFillSafetySvg,
	IconFillBestRateSvg,
	IconFillPrioritizedSvg,
	IconFillTailorBenefitsSvg,
};
